import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { formatDate, isBuyer } from "../../util/helper";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import { Button, Card, Image, List, Modal, notification } from "antd";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import SubscriptionPlans from "../subscriptionPlan/subscriptionPlan";
import { fetchStart, fetchSuccess, getBuyerOfferProductsById } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";


const AdminToBuyerOfferProductView = () => {
    const history = useHistory();
    const { isMobile } = useGetBreakpoints();
    const dispatch = useDispatch();
    const [fileName, setFileName] = useState("");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
    const userData = useSelector(({ auth }) => auth?.userData);
    const [userDatas, setUserDatas] = useState(userData);

    const handleCloseSubscriptionPlans = () => {
        setShowSubscriptionPlans(false);
    };
    const handleCreateRfq = () => {
        history.push({
            pathname: "/rfq/details",
            state: {
                productName: buyerOfferProduct?.data?.name,
                hsCodeId: buyerOfferProduct?.data?.hsCodeId,
                categoryId: buyerOfferProduct?.data?.categoryId,
            },
        });
    };
    const handleBack = () => {
        history.goBack();
    };
    const handleViewProfile = (id) => {
        if (id) {
            history.push(`/user-profile?id=${id}`);
        }
    };
    const [buyerOfferProduct, setBuyerOfferProduct] = useState(null);

    const getAdminToBuyerOfferProductsById = async () => {
        try {
            dispatch(fetchStart());
            const response = await axiosInstance.get(
                `${BASE_API_CONFIG.baseURL}/admin-offer-products/buyer/${id}`
            );
            setBuyerOfferProduct(response?.data);
        } catch (error) {
            notification.error({
                message: "Failed",
                description:
                    error?.response?.data?.message || "Failed to fetch admin offers to buyer"
            });
        } finally {
            dispatch(fetchSuccess());
        }
    }
    //   const buyerOfferProduct = useSelector(
    //     (state) => state.exporterOfferProducts.buyerProductDetailsById
    //   );
    useEffect(() => {
        if (id) {
            getAdminToBuyerOfferProductsById()
        }
    }, [id, dispatch]);

    useEffect(() => {
        const images = buyerOfferProduct?.data.primaryImage;
        if (Array.isArray(images)) {
            setFileName(images);
        } else if (typeof images === "string" && images) {
            setFileName([{ src: images }]);
        }
    }, [buyerOfferProduct]);

    const styles = {
        closeButton: {
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            fontWeight: "bold",
            background: "#ffffff",
            border: "1px solid #e8e8e8",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            zIndex: 1000,
        },
    };
    const now = new Date();
    const expiryDate = new Date(buyerOfferProduct?.data.expiryDate);
    const today = new Date(now.setHours(0, 0, 0, 0));
    const expiryDay = new Date(expiryDate.setHours(0, 0, 0, 0));

    const isExpired = today > expiryDay;

    const data = [
        {
            label: "Posted Date",
            value: formatDate(buyerOfferProduct?.data.createdAt),
        },
        {
            label: "Product Name",
            value: buyerOfferProduct?.data.name,
        },
        {
            label: isBuyer(userData) ? "FOB Price" : "FOR Price",
            value: `${buyerOfferProduct?.data.currency} ${buyerOfferProduct?.data.price} / ${buyerOfferProduct?.data.uom}`,
        },
        {
            label: "Payment Terms",
            value: buyerOfferProduct?.data.comments,
        },
    ];

    return (
        isValidElement(buyerOfferProduct) && (
            <>
                <Card className="myexim-detail-card">
                    <div className="myexim-table-title">
                        <div>
                            <LeftOutlined
                                // className={"back-icon"}
                                style={{ fontSize: "20px", color: "#434E5B" }}
                                size="large"
                                onClick={() => {
                                    history.goBack();
                                }}
                            />
                        </div>
                        Offer Product Details
                    </div>
                    <div
                        className={`logo-with-list gx-mt-4 ${isMobile ? "gx-flex-column" : ""
                            }`}
                    >
                        <div style={{ flex: 1 }}>
                            <List
                                itemLayout="horizontal"
                                dataSource={data}
                                renderItem={(item) =>
                                    item?.value && (
                                        <List.Item className="myexim-details-list">
                                            <List.Item.Meta
                                                title={<div>{item.label}</div>}
                                                description={
                                                    isValidString(item.value) ? item.value : "-"
                                                }
                                            />
                                        </List.Item>
                                    )
                                }
                            />
                            {fileName?.length > 0 && (
                                <div className="attachments gx-mt-3">
                                    <div className="sub-header ">Attachments</div>
                                    <div className="gx-mt-4">
                                        Please find the below attachment as a reference
                                    </div>
                                    <div className="gx-pt-4">
                                        {fileName?.map((file, index) => (
                                            <div key={index} className="gx-pb-3">
                                                <Image
                                                    className="gx-rounded-lg"
                                                    width={isMobile ? "100%" : 150}
                                                    height={isMobile ? "100%" : 150}
                                                    src={file?.src}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: isMobile ? "center" : "end",
                            flex: 1,
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            type="secondary"
                            size="large"
                            onClick={handleBack}
                            className="submit-btn"
                            style={{ marginRight: isMobile ? 0 : "" }}
                        >
                            Back
                        </Button>
                        {isBuyer(userData) &&
                            <Button
                                type="primary"
                                disabled={isExpired}
                                size="large"
                                onClick={handleCreateRfq}
                                className="submit-btn"
                            >
                                Request for CIF Price
                            </Button>
                        }
                    </div>
                </Card>

                <Modal
                    open={showSubscriptionPlans}
                    onCancel={handleCloseSubscriptionPlans}
                    closeIcon={<CloseOutlined style={styles.closeButton} />}
                    footer={null}
                    width={800}
                >
                    <SubscriptionPlans
                        userDatas={userDatas}
                        setUserDatas={setUserDatas}
                    />
                </Modal>
            </>
        )
    );
};

export default AdminToBuyerOfferProductView;

